(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("@duik/create-simple-component"), require("@duik/button"), require("@duik/outer-events-handler"));else if (typeof define === 'function' && define.amd) define(["@duik/create-simple-component", "@duik/button", "@duik/outer-events-handler"], factory);else {
    var a = typeof exports === 'object' ? factory(require("@duik/create-simple-component"), require("@duik/button"), require("@duik/outer-events-handler")) : factory(root["@duik/create-simple-component"], root["@duik/button"], root["@duik/outer-events-handler"]);

    for (var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
  }
})(this, function (__WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__6__, __WEBPACK_EXTERNAL_MODULE__7__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // define __esModule on exports

      /******/


      __webpack_require__.r = function (exports) {
        /******/
        if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/
          Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/


        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/

      /******/
      // create a fake namespace object

      /******/
      // mode & 1: value is a module id, require it

      /******/
      // mode & 2: merge all properties of value into the ns

      /******/
      // mode & 4: return value when already ns object

      /******/
      // mode & 8|1: behave like require

      /******/


      __webpack_require__.t = function (value, mode) {
        /******/
        if (mode & 1) value = __webpack_require__(value);
        /******/

        if (mode & 8) return value;
        /******/

        if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
        /******/

        var ns = Object.create(null);
        /******/

        __webpack_require__.r(ns);
        /******/


        Object.defineProperty(ns, 'default', {
          enumerable: true,
          value: value
        });
        /******/

        if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
          return value[key];
        }.bind(null, key));
        /******/

        return ns;
        /******/
      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 92);
      /******/
    }
    /************************************************************************/

    /******/
    ({
      /***/
      0:
      /***/
      function (module, exports) {
        module.exports = require("react");
        /***/
      },

      /***/
      1:
      /***/
      function (module, exports) {
        module.exports = require("classnames");
        /***/
      },

      /***/
      136:
      /***/
      function (module, exports) {
        // removed by extract-text-webpack-plugin
        module.exports = {
          "modal": "modal",
          "sm": "sm",
          "lg": "lg",
          "full": "full",
          "modal-body": "modal-body",
          "modal-header": "modal-header",
          "modal-footer": "modal-footer",
          "modal-body-secondary": "modal-body-secondary",
          "modal-btn-close": "modal-btn-close",
          "modal-close-icon": "modal-close-icon",
          "overlay": "overlay"
        };
        /***/
      },

      /***/
      2:
      /***/
      function (module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE__2__;
        /***/
      },

      /***/
      50:
      /***/
      function (module, exports) {
        module.exports = require("react-dom");
        /***/
      },

      /***/
      51:
      /***/
      function (module, exports) {
        module.exports = require("react-transition-group");
        /***/
      },

      /***/
      6:
      /***/
      function (module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE__6__;
        /***/
      },

      /***/
      7:
      /***/
      function (module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE__7__;
        /***/
      },

      /***/
      92:
      /***/
      function (module, __webpack_exports__, __webpack_require__) {
        "use strict"; // ESM COMPAT FLAG

        __webpack_require__.r(__webpack_exports__); // EXPORTS


        __webpack_require__.d(__webpack_exports__, "Modal", function () {
          return (
            /* binding */
            Modal
          );
        }); // EXTERNAL MODULE: external "react"


        var external_react_ = __webpack_require__(0);

        var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_); // EXTERNAL MODULE: external "classnames"


        var external_classnames_ = __webpack_require__(1);

        var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_); // EXTERNAL MODULE: external "@duik/outer-events-handler"


        var outer_events_handler_ = __webpack_require__(7); // EXTERNAL MODULE: external "@duik/button"


        var button_ = __webpack_require__(6); // EXTERNAL MODULE: external "react-dom"


        var external_react_dom_ = __webpack_require__(50);

        var external_react_dom_default = /*#__PURE__*/__webpack_require__.n(external_react_dom_); // EXTERNAL MODULE: external "react-transition-group"


        var external_react_transition_group_ = __webpack_require__(51); // EXTERNAL MODULE: ./packages/Modal/styles.scss


        var styles = __webpack_require__(136);

        var styles_default = /*#__PURE__*/__webpack_require__.n(styles); // CONCATENATED MODULE: ./packages/Modal/Overlay.tsx


        var Overlay = function (props) {
          var isOpen = props.isOpen,
              children = props.children,
              _a = props.portalEl,
              portalEl = _a === void 0 ? document === null || document === void 0 ? void 0 : document.body : _a;

          if (portalEl) {
            return external_react_dom_default.a.createPortal(external_react_default.a.createElement(external_react_transition_group_["CSSTransition"], {
              in: isOpen,
              timeout: 50,
              unmountOnExit: true
            }, external_react_default.a.createElement("div", {
              className: styles_default.a['overlay']
            }, children)), portalEl);
          }

          return null;
        };
        /* harmony default export */


        var Modal_Overlay = Overlay; // EXTERNAL MODULE: external "@duik/create-simple-component"

        var create_simple_component_ = __webpack_require__(2); // CONCATENATED MODULE: ./packages/Modal/ModalBody.tsx


        var ModalBody = Object(create_simple_component_["createSimpleComponent"])({
          Component: 'div',
          className: styles_default.a['modal-body'],
          displayName: 'ModalBody'
        }); // CONCATENATED MODULE: ./packages/Modal/ModalHeader.tsx

        var ModalHeader = Object(create_simple_component_["createSimpleComponent"])({
          Component: 'div',
          className: styles_default.a['modal-header'],
          displayName: 'ModalHeader'
        }); // CONCATENATED MODULE: ./packages/Modal/ModalFooter.tsx

        var ModalFooter = Object(create_simple_component_["createSimpleComponent"])({
          Component: 'div',
          className: styles_default.a['modal-footer'],
          displayName: 'ModalFooter'
        }); // CONCATENATED MODULE: ./packages/Modal/ModalTitle.tsx

        var ModalTitle = Object(create_simple_component_["createSimpleComponent"])({
          Component: 'h2',
          displayName: 'ModalTitle'
        }); // CONCATENATED MODULE: ./packages/Modal/ModalBodySecondary.tsx

        var ModalBodySecondary = Object(create_simple_component_["createSimpleComponent"])({
          Component: 'div',
          className: external_classnames_default()(styles_default.a['modal-body'], styles_default.a['modal-body-secondary']),
          displayName: 'ModalBodySecondary'
        }); // CONCATENATED MODULE: ./packages/Modal/index.tsx

        var __assign = undefined && undefined.__assign || function () {
          __assign = Object.assign || function (t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];

              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }

            return t;
          };

          return __assign.apply(this, arguments);
        };

        var __rest = undefined && undefined.__rest || function (s, e) {
          var t = {};

          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

          if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
          }
          return t;
        };

        var Modal = function (props) {
          var _a;

          var isOpen = props.isOpen,
              handleClose = props.handleClose,
              sm = props.sm,
              full = props.full,
              lg = props.lg,
              children = props.children,
              className = props.className,
              _b = props.hideCloseButton,
              hideCloseButton = _b === void 0 ? false : _b,
              portalEl = props.portalEl,
              disablePortal = props.disablePortal,
              closeOnOuterClick = props.closeOnOuterClick,
              rest = __rest(props, ["isOpen", "handleClose", "sm", "full", "lg", "children", "className", "hideCloseButton", "portalEl", "disablePortal", "closeOnOuterClick"]);

          var el = external_react_default.a.createElement(outer_events_handler_["OuterEventsHandler"], __assign({
            className: external_classnames_default()(styles_default.a['modal'], className, (_a = {}, _a[styles_default.a['lg']] = lg, _a[styles_default.a['sm']] = sm, _a[styles_default.a['full']] = full, _a)),
            onOuterEvent: closeOnOuterClick ? handleClose : undefined
          }, rest), handleClose && !hideCloseButton && external_react_default.a.createElement(button_["Button"], {
            onClick: handleClose,
            "aria-label": "Close",
            square: true,
            clear: true,
            className: styles_default.a['modal-btn-close']
          }, external_react_default.a.createElement("span", {
            className: styles_default.a['modal-close-icon']
          })), children);

          if (disablePortal) {
            return el;
          }

          return external_react_default.a.createElement(Overlay, {
            isOpen: isOpen,
            portalEl: portalEl
          }, el);
        };

        Modal.displayName = 'Modal';
        Modal.Body = ModalBody;
        Modal.BodySecondary = ModalBodySecondary;
        Modal.Header = ModalHeader;
        Modal.Footer = ModalFooter;
        Modal.Title = ModalTitle;
        /* harmony default export */

        var packages_Modal = __webpack_exports__["default"] = Modal;
        /***/
      }
      /******/

    })
  );
});